import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  PaginationItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import MainSidebar from "../../../Layout/MainSidebar";
import GroupAdminSidebar from "../../../Layout/GroupAdminSidebar";
import { get } from "../../../utils/api";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import AddIcon from "@mui/icons-material/Add";
import AddMis from "./AddMis";
import MessagePopup from "../../../Components/Masters/MessagePopup";
import PaginationBox from "../../../Components/Masters/Pagination";
import styled from "styled-components";
import { useUser } from "../../../context/AuthContext";
import useAuthStore from "../../../store/ContextUser";
const MisReportList = () => {
  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const navigate = useNavigate();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [data, setData] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const tableContainerRef = useRef(null); // Reference to the table container
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;

    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height

      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data, selectedCompany]);

  const getMisList = async () => {
    try {
      let res = await get(
        `/mis-report/list?page=${page}&companyId=${selectedCompany?._id}`
      );
      let arr = res?.data?.data.map((item) => ({
        title: item?.reportingMonth,
        createdAt: new Date(item?.updatedAt).toLocaleDateString("en-IN"),
        preparationDate: new Date(item?.preparationDate).toLocaleDateString(
          "en-IN"
        ),
        typeOfReport: item?.typeOfReport,
        facilityName: item?.facility?.facilityName,
        _id: item?._id,
      }));
      setData(arr);
      setTotalPages(res?.data?.totalPages); // Update total pages for pagination

      console.log("res", res?.data);
    } catch (error) {
      console.log("first", error);
      setData([]);
    }
  };

  useEffect(() => {
    getMisList();
  }, [page, selectedCompany]);

  // useEffect(() => {
  //   setData([]);
  // }, [selectedCompany]);

  const commonCellStyle = {
    padding: "8px",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    border: "1px solid #DBDBDB",
    color: "#222222",
  };

  const headerCellStyle = {
    ...commonCellStyle,
    fontWeight: "600",
    fontSize: "18px",
    whiteSpace: "nowrap",
    letterSpacing: "0.5px",
  };

  const actionCellStyle = {
    ...commonCellStyle,
    textDecoration: "underline",
    cursor: "pointer",
  }; 

  return (
    <MainDashboardLayout
      sidebar={user?.groupManager ? <GroupAdminSidebar /> : <MainSidebar />}
    >
      <Unauthorized requiredModule="MIS Report">
        <>
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          <AddMis
            handleClose={() => {
              setIsModalOpen(false);
              getMisList();
            }}
            title="Waste Generated in Operations"
            addData={isModalOpen}
            addUrl={`scope3/wasteGeneratedInOperations/add`}
            updateUrl={`scope3/wasteGeneratedInOperations/update`}
            {...{
              setsnackOpen,
            }}
          />
          <Box
            item
            xs={6}
            sx={{
              paddingLeft: 0,
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
            }}
          >
            <p
              style={{
                margin: "1rem 0",
                fontFamily: "Inter",
                fontSize: "22px",
                fontWeight: "700",
                // marginTop: "2rem",
              }}
            >
              MIS Reports
            </p>
            {user?.groupManager ? null : (
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "16px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  height: "2.5rem",
                  mt: "1rem",
                  "&:hover": {
                    backgroundColor: "#1c486b",
                    opacity: 0.9,
                  },
                }}
                onClick={() => setIsModalOpen(true)}
              >
                Add New
              </Button>
            )}
          </Box>
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            style={{ marginTop: "1rem", backgroundColor: "#FCFCFC" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {["S.No", "Title", "Coverage", "Create Date", "Action"].map(
                    (header, index) => (
                      <TableCell key={index} style={headerCellStyle}>
                        {header}
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    <TableCell style={commonCellStyle}>
                      {(page - 1) * 10 + rowIndex + 1}
                    </TableCell>
                    <TableCell style={commonCellStyle}>{row.title}</TableCell>
                    <TableCell style={commonCellStyle}>
                      {row?.typeOfReport === "Facility"
                        ? row?.facilityName
                        : row?.typeOfReport}
                    </TableCell>
                    <TableCell style={commonCellStyle}>
                      {row?.preparationDate ?? row?.updatedAt}
                    </TableCell>
                    <TableCell
                      style={actionCellStyle}
                      onClick={() => navigate(`/mis-report/${row._id}?year=${row?.title.split(" ")[1]}`)}
                    >
                                      View
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
        </>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default MisReportList;
